import React, { useEffect, useState } from 'react';
import { AppLanguage, specialLanguageHotelMapping } from 'const';
import { useDispatch, useSelector } from 'react-redux';
import { selectCurrentLanguage, setLanguage } from 'store/slice/appConfigSlice';
import { useHistory, useLocation } from 'react-router-dom';
import { Box, Select, MenuItem, FormControl } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { selectHotelConfig } from 'store/slice/hotelConfigSlice';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'row',
    gap: '0.5em',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  activeButton: {
    fontWeight: 'bold',
    backgroundColor: 'black',
    color: 'white',
    padding: '0.5em 1em',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: 'gray',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0.75em 1.5em',
    },
  },
  inactiveButton: {
    backgroundColor: 'white',
    color: 'black',
    padding: '0.5em 1em',
    borderRadius: '5px',
    '&:hover': {
      backgroundColor: 'lightgray',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '0.75em 1.5em',
    },
  },
}));

export const LanguageSwitcher: React.FC = () => {
  const dispatch = useDispatch();
  const currentLanguage = useSelector(selectCurrentLanguage);
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const hotelConfig = useSelector(selectHotelConfig);
  const [languageMapping, setLanguageMapping] = useState({
    en: 'EN',
    cn: '简',
    hk: '繁',
    jp: '日',
    kr: '한',
  }) as any;

  const [appLanguageState, setAppLanguageState] = useState<AppLanguage | {}>(
    AppLanguage
  );

  const handleLanguageChange = (lang: AppLanguage) => {
    dispatch(setLanguage(lang));
    const toLocation = location.pathname.replace(/\/[a-z]{2}\//, `/${lang}/`);
    history.push(toLocation);
  };

  useEffect(() => {
    if (hotelConfig.languages && hotelConfig.languages.length > 0) {
      const filteredLanguages = Object.entries(languageMapping).reduce(
        (acc: Array<Record<string, unknown>>, [key, value]) => {
          if (hotelConfig.languages.includes(key as AppLanguage)) {
            acc.push({ [key]: value });
          }
          return acc;
        },
        []
      );
      const mergedLanguages = Object.assign({}, ...filteredLanguages) as {
        [k in AppLanguage]: string;
      };
      setLanguageMapping(mergedLanguages);

      const appLanguages = Object.keys(mergedLanguages).reduce(
        (acc: { [key: string]: AppLanguage }, key: string) => {
          acc[key] = key as AppLanguage;
          return acc;
        },
        {}
      );
      setAppLanguageState(appLanguages);
    }
  }, [hotelConfig]);

  return (
    <Box className={classes.container}>
      <FormControl variant="outlined" fullWidth>
        <Select
          labelId="language-select-label"
          value={currentLanguage}
          onChange={(e) => handleLanguageChange(e.target.value as AppLanguage)}
        >
          {Object.keys(appLanguageState).map((lang) => (
            <MenuItem key={lang} value={appLanguageState[lang]}>
              {languageMapping[appLanguageState[lang]]}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};
